import { z } from "zod";
import { SIGNUP_SOURCES } from "./signup-source";

const SIGNUP_SOURCE_VALUES = SIGNUP_SOURCES.map((s) => s.value) as [string, ...string[]];

export const formSchema = z.object({
   name: z
      .string()
      .min(2, { message: 'Name must be at least 2 characters long' })
      .max(50, { message: 'Name cannot exceed 50 characters' }),

   email: z
      .string()
      .email({ message: 'Please enter a valid email address' })
      .min(2)
      .max(50),

   password: z
      .string()
      .min(10, { message: "Password must be at least 10 characters long" })
      .max(100, { message: "Password cannot exceed 100 characters" }),

   // Facultatif : ne doit pas bloquer l'inscription si l'élève ne sait pas
   // ou ne veut pas répondre.
   signupSource: z.enum(SIGNUP_SOURCE_VALUES).optional(),
})

export const signInFormSchema = formSchema.pick({
   email: true,
   password: true
})